<template>
  


  <section class="preview">


    <div>
      <mdb-modal fullHeight position="top" :show="modalState" @close="modalState = false">
        <mdb-modal-header>
          <mdb-modal-title>Crear estado</mdb-modal-title>
        </mdb-modal-header>
        <form novalidate @submit.prevent="crearState">
          <mdb-modal-body>
            <mdb-input
              placeholder="Nombre de estado"
              class="mb-3 mt-0"
              v-model="newState.name"
              required
              invalidFeedback="Coloca el nombre"
            >
              <span class="input-group-text md-addon" slot="prepend">Nombre de estado</span>
            </mdb-input>

            <mdb-input
              placeholder="Codigo de estado"
              class="mb-3 mt-0"
              v-model="newState.code"
              required
              invalidFeedback="Coloca el nombre"
            >
              <span class="input-group-text md-addon" slot="prepend">Código de estado</span>
            </mdb-input>

            <div class="form-group">
              <label class="typo__label">País</label>
              <multiselect
                v-model="newState.country"
                placeholder="Seleccione el País"
                label="name"
                track-by="id"
                :options="countries"
                :multiple="false"
                :taggable="false"
              ></multiselect>
            </div>

            
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="secondary" @click.native="modalState = false">Cerrar</mdb-btn>
            <mdb-btn type="submit" color="primary" :disabled="isLoadingState">
              <span v-if="!isLoadingState">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingState"
              ></semipolar-spinner>
            </mdb-btn>
          </mdb-modal-footer>
        </form>
      </mdb-modal>
    </div>
    

    <div>
      <mdb-modal fullHeight position="top" :show="modalTitle" @close="modalTitle = false">
        <mdb-modal-header>
          <mdb-modal-title>Crear Titulo</mdb-modal-title>
        </mdb-modal-header>
        <form novalidate @submit.prevent="crearTitle">
          <mdb-modal-body>
            <mdb-input
              placeholder="Nombre de título"
              class="mb-3 mt-0"
              v-model="newTitle.title"
              required
              invalidFeedback="Coloca el nombre"
            >
              <span class="input-group-text md-addon" slot="prepend">Título</span>
            </mdb-input>

            <mdb-input
              placeholder="Abreviación"
              class="mb-3 mt-0"
              v-model="newTitle.abbreviation"
              required
              invalidFeedback="Coloca el nombre"
            >
              <span class="input-group-text md-addon" slot="prepend">Abreviación</span>
            </mdb-input>

            

            
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="secondary" @click.native="modalTitle = false">Cerrar</mdb-btn>
            <mdb-btn type="submit" color="primary" :disabled="isLoadingTitle">
              <span v-if="!isLoadingTitle">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingTitle"
              ></semipolar-spinner>
            </mdb-btn>
          </mdb-modal-footer>
        </form>
      </mdb-modal>
    </div>

    <div>
      <mdb-modal fullHeight position="top" :show="modalIdeologia" @close="modalIdeologia = false">
        <mdb-modal-header>
          <mdb-modal-title>Crear ideología</mdb-modal-title>
        </mdb-modal-header>
        <form novalidate @submit.prevent="crearIdeologia">
          <mdb-modal-body>
            <mdb-input
              label="Nombre de ideologia"
              class="mb-3 mt-0"
              v-model="newIdeologia.name"
              required
              invalidFeedback="Coloca el nombre"
            ></mdb-input>
            <mdb-input
              type="number"
              label="Alcance Potencial"
              class="mb-3 mt-0"
              v-model="newIdeologia.reach_estimate"
              required
              invalidFeedback="Coloca el alcance potencial"
            ></mdb-input>
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="secondary" @click.native="modalIdeologia = false">Cerrar</mdb-btn>
            <mdb-btn type="submit" color="primary" :disabled="isLoadingIdeologia">
              <span v-if="!isLoadingIdeologia">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoadingIdeologia"
              ></semipolar-spinner>
            </mdb-btn>
          </mdb-modal-footer>
        </form>
      </mdb-modal>
    </div>
    


    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <!--<div class="prueba-circulo offset-3 mb-3"></div>-->

      <!--<b-form-file
        v-model="file"
        id="input-file"
        :state="Boolean(file)"
        @change="avatarChange"
        class="mb-3"
        placeholder="Sube una imagen"
        drop-placeholder="Suelta el archivo aqui..."
      ></b-form-file>-->
      <mdb-input
        placeholder="Nombre Completo"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      
      <mdb-input
        placeholder="Local"
        class="mb-3 mt-0"
        v-model="phone"
        required
        invalidFeedback="Coloca un número"
      >
        <span class="input-group-text md-addon" slot="prepend">Télefono local</span>
      </mdb-input>

      <mdb-input
        placeholder="Movil"
        class="mb-3 mt-0"
        v-model="mobile"
        required
        invalidFeedback="Coloca un número"
      >
        <span class="input-group-text md-addon" slot="prepend">Télefono celular</span>
      </mdb-input>

      <mdb-input
        placeholder="Fax"
        class="mb-3 mt-0"
        v-model="fax"
        required
        invalidFeedback="Coloca el fax"
      >
        <span class="input-group-text md-addon" slot="prepend">Fax</span>
      </mdb-input>

      <mdb-input
        placeholder="Correo"
        class="mb-3"
        v-model="email"
        required
        invalidFeedback="Coloca el correo"
      >
        <span class="input-group-text md-addon" slot="prepend">Correo</span>
      </mdb-input>

       <mdb-input
        placeholder="Ejemplo: Director general"
        class="mb-3 mt-0"
        v-model="job_position"
        required
        invalidFeedback="Coloca tu puesto"
      >
        <span class="input-group-text md-addon" slot="prepend">Posición de trabajo</span>
      </mdb-input>

      <mdb-input
        placeholder="Web"
        class="mb-3 mt-0"
        v-model="website"
        required
        invalidFeedback="Coloca tu web"
      >
        <span class="input-group-text md-addon" slot="prepend">Web</span>
      </mdb-input>

      <mdb-input
        placeholder="Ejemplo: BE0477472701"
        class="mb-3 mt-0"
        v-model="tax_id"
        required
        invalidFeedback="Coloca un TAX ID"
      >
        <span class="input-group-text md-addon" slot="prepend">Tax ID</span>
      </mdb-input>

      <mdb-input
        placeholder="Calle..."
        class="mb-3 mt-0"
        v-model="street"
        required
        invalidFeedback="Dirección de calle obligatoria"
      >
        <span class="input-group-text md-addon" slot="prepend">Calle 1</span>
      </mdb-input>

      <mdb-input
        placeholder="Calle 2..."
        class="mb-3 mt-0"
        v-model="street_2"
        invalidFeedback="Dirección de calle 2"
      >
        <span class="input-group-text md-addon" slot="prepend">Calle 2</span>
      </mdb-input>

       <mdb-input
        placeholder="Ciudad"
        class="mb-3 mt-0"
        v-model="city"
        required
        invalidFeedback="Ciudad requerida"
      >
        <span class="input-group-text md-addon" slot="prepend">Ciudad</span>
      </mdb-input>

      <mdb-input
        placeholder=""
        class="mb-3 mt-0"
        v-model="campaign_name_template"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre de template Campaña</span>
      </mdb-input>

      <mdb-input
        placeholder=""
        class="mb-3 mt-0"
        v-model="adset_name_template"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre de template AdsetAdset</span>
      </mdb-input>

      <mdb-input
        placeholder=""
        class="mb-3 mt-0"
        v-model="ad_name_template"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre de template Ad</span>
      </mdb-input>



      <div class="form-group">
        
        <label class="typo__label mr-2">País</label>
        <span  v-if="error.country" class="badge badge-danger">Obligatorio</span>
        <multiselect
          v-model="selectedCountry"
          placeholder="Seleccione el País"
          label="name"
          track-by="id"
          @select="getStates"
          :options="countries"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <div class="form-group" >
        <label class="typo__label">
          Estado
           <i class="fas fa-plus-circle icono-crear mr-1" @click="modalState = true"></i>
        </label>
        <multiselect
          v-model="selectedState"
          placeholder="Seleccione el estado"
          label="name"
          track-by="id"
          :options="states"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      

     

      <div class="form-group">
        <label class="typo__label">Titulo
          <i class="fas fa-plus-circle icono-crear mr-1" @click="modalTitle = true"></i>
        </label>
        <multiselect
          v-model="selectedTitle"
          placeholder="Seleccione el País"
          label="name"
          track-by="id"
          :options="titles"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>

      <!--<div class="form-group">
        <label class="typo__label">Idioma
        </label>
        <multiselect
          v-model="idiomaSelected"
          placeholder="Seleccione un idioma"
          label="name"
          track-by="id"
          :options="idiomas"
          :multiple="false"
          :taggable="false"
        ></multiselect>
      </div>-->

      

      <div class="form-group">
        <label class="typo__label mr-2">Páginas</label>
        <span  v-if="error.page" class="badge badge-danger">Obligatorio</span>
        <multiselect
          v-model="pagesSelected"
          :options="pages"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona páginas"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label mr-2">Cuentas ads</label>
        <span  v-if="error.account" class="badge badge-danger">Obligatorio</span>
        <multiselect
          v-model="accountsSelected"
          :options="accounts"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona Cuentas"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label mr-2">
          Estrategias de acción
          <i class="fas fa-plus-circle icono-crear mr-1" @click="()=>openModalStrategy()"></i>
        </label>
        <span  v-if="error.strategy" class="badge badge-danger">Obligatorio</span>
        <multiselect
          v-model="strategyActionsSelected"
          :options="strategyActions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona estrategias"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="form-group">
        <label class="typo__label mr-2">
          Ideologías
          <i class="fas fa-plus-circle icono-crear mr-1" @click="modalIdeologia = true"></i>
        </label>
        <span  v-if="error.ideology" class="badge badge-danger">Obligatorio</span>
        <multiselect
          v-model="ideologySelected"
          :options="ideologys"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona ideologías"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import ModalCreateStrategyAction from "../notifications/ModalCreateStrategyAction";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbContainer,
    ModalCreateStrategyAction,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function,
    modalStrategy: Function
  },
  data: () => {
    return {
      isLoading: false,
      isLoadingState:false,
      modalState:false,
      modalTitle:false,
      modalIdeologia:false,
      isLoadingIdeologia:false,
      isLoadingTitle:false,
      name: "",
      email: "",
      file: null,
      imagenSrc: "",
      street: "",
      street_2:"",
      tax_id:"",
      city:"",
      job_position:"",
      website: "",
      phone: "",
      idiomaSelected:{},
      mobile: "",
      fax: "",
      campaign_name_template:"",
      adset_name_template:"",
      ad_name_template:"",
      newState:{
        name:"",
        code:"",
        country:{}
      },
      newTitle:{
        title:"",
        abbreviation:""
      },
      newIdeologia:{
        name:'',
        reach_estimate:''
      },
      countries: [],
      states:[],
      pages: [],
      accounts: [],
      titles:[],
      ideologys:[],
      idiomas:[{id:1,name:"Ingles"}],
      strategyActions:[],
      selectedCountry: {},
      selectedState: {},
      selectedTitle:{},
      pagesSelected: [],
      accountsSelected: [],
      strategyActionsSelected:[],
      ideologySelected:[],
      error:{
        country:false,
        page:false,
        account:false,
        stategy:false,
        ideology:false
      }
    };
  },
  async mounted() {
    var respuesta = await this.getCountries();
    respuesta = await this.getTitles();
    respuesta = await this.getPages();
    respuesta = await this.getBusinessAccounts();
    respuesta = await this.getStrategyActions();
    respuesta = await this.getIdeologias();
  },
  methods: {
    async getCountries() {
      var countries = store.getters.getCountries;
      if (countries.length == 0) {
        await store.dispatch("getCountries").then(() => {
          countries = store.getters.getCountries;
          this.countries = countries;
          this.countriesIncludes = countries;
          this.countriesExclude = countries;
          return;
        });
      } else {
        this.countries = countries;
        this.countriesIncludes = countries;
        this.countriesExclude = countries;
        return;
      }
    },
    async getPages() {
      var pages = store.getters.getFacebookPages;
      if (pages.length == 0) {
        await store.dispatch("getFacebookPages").then(() => {
          pages = store.getters.getFacebookPages;
          this.pages = pages;
          return;
        });
      } else {
        this.pages = pages;
        return;
      }
    },
    async getBusinessAccounts() {
      var accounts = store.getters.getAdsAccounts;
      if (accounts.length == 0) {
        await store.dispatch("getAdsAccounts").then(() => {
          accounts = store.getters.getAdsAccounts;
          this.accounts = accounts;
          return;
        });
      } else {
        this.accounts = accounts;
        return;
      }
    },
    async getStates(opcion){
     this.states = []
     this.selectedState = {}
      var country_id = opcion.id;
      await store.dispatch("getStateCountry",country_id).then(() => {
          var states = store.getters.getStates;
          this.states= states;
        });
    },
     async getTitles() {
      var titles = store.getters.getTitles;
      if (titles.length == 0) {
        await store.dispatch("getTitles").then(() => {
          titles = store.getters.getTitles;
          this.titles = titles;
          return;
        });
      } else {
        this.titles = titles;
        return;
      }
    },
    async getStrategyActions() {
      var strategyActions = store.getters.getStrategyActions;
      if (strategyActions.length == 0) {
        store.dispatch("getStrategyActions").then(() => {
          strategyActions = store.getters.getStrategyActions;
          this.strategyActions = strategyActions;
          return;
        });
      } else {
        this.strategyActions = strategyActions;
        return;
      }
    },
    getIdeologias() {
      var ideologias = store.getters.getIdeologias;
      if (ideologias.length == 0) {
        store.dispatch("getIdeologias").then(() => {
          ideologias = store.getters.getIdeologias;
          this.ideologys = ideologias;
        });
      } else {
        this.ideologys = ideologias;
      }
    },
    crearState(){
      this.isLoadingState = true;
      var {name,code,country} = this.newState;
      var country_id = country.id
      if (
        name == "" ||
        code == "" ||
        country_id == ""){
          this.isLoadingState = false;
        }else{
          var state = {
            name,
            code,
            country_id,
            country
          }
          store.dispatch("newStateCountry", state).then(() => {
          this.newState = {
            name:"",
            code:"",
            country:{}
          };
          this.modalState = false
          this.isLoadingState = false;
        });
        }

    },
    crearTitle(){
      this.isLoadingTitle = true;
      var {title,abbreviation} = this.newTitle;
  
      if (
        title == "" ||
        abbreviation == "" ){
          this.isLoadingTitle = false;
        }else{
          var newTitle = {
            title,
            abbreviation,
          }
          store.dispatch("newTitle", newTitle).then(() => {
          this.newTitle = {
            title:"",
            abbreviation:""
          };
          this.modalTitle = false
          this.isLoadingTitle = false;
        });
        }
    },
    avatarChange(event) {
      var fileInput = document.getElementById("input-file");
      var filePath = event.target.value;
      var allowedExtensions = /(.jpg|.jpeg|.png)$/i;
      if (!allowedExtensions.exec(filePath)) {
        alert(
          "Please upload file having extensions .jpeg/.jpg/.png/.gif only."
        );
        fileInput.value = "";
        return false;
      } else {
        //Image preview
        if (fileInput.files && fileInput.files[0]) {
          var reader = new FileReader();
          reader.onload = e => {
            this.imagenSrc = e.target.result;
            var prueba = document.getElementsByClassName("prueba-circulo")[0];
            prueba.style.backgroundImage = "url(" + e.target.result + ")";
            prueba.style.backgroundPosition = "center";
            prueba.style.backgroundSize = "100%";
          };

          reader.readAsDataURL(fileInput.files[0]);
        }
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
        name,
        email,
        street,
        city,
        street_2,
        website,
        phone,
        mobile,
        tax_id,
        fax,
        selectedCountry,
        pagesSelected,
        accountsSelected,
        strategyActionsSelected,
        ideologySelected,
        campaign_name_template,
        adset_name_template,
        ad_name_template
      } = this;

      this.isLoading = true;
      if (
        name == "" ||
        email == "" ||
        street == "" ||
        website == "" ||
        phone == "" ||
        mobile == "" ||
        fax == "" ||
        tax_id == "" ||
        campaign_name_template == "" ||
      adset_name_template  == "" ||
      ad_name_template  == "" ||
        !selectedCountry.hasOwnProperty("id") ||
        pagesSelected.length == 0 ||
        accountsSelected.length == 0 ||
        strategyActionsSelected.length == 0 ||
        ideologySelected.length == 0
      ) {
        if(!selectedCountry.hasOwnProperty("id")){
          this.error.country = true
        }
        if(pagesSelected.length == 0){
          this.error.page = true
        }
        if(accountsSelected.length == 0 ){
          this.error.account =true
        }
        if(strategyActionsSelected.length == 0 ){
          this.error.strategy = true
        }
        if(ideologySelected.length == 0){
          this.error.ideology = true
        }
        window.scrollTo(0,0)
        this.isLoading = false;
      } else {
        var pages_ids = [];
        var ad_account_ids = [];
        var strategic_ids = [];
        var ideology_ids = [];

        accountsSelected.map(i => {
          ad_account_ids.push(i.id);
        });
        pagesSelected.map(i => {
          pages_ids.push(i.id);
        });
        strategyActionsSelected.map(i => {
          strategic_ids.push(i.id);
        });
        ideologySelected.map(i => {
          ideology_ids.push(i.id);
        });

        var partner = {
          name,
          website,
          street,
          street2:street_2,
          position:this.job_position,
          city,
          phone,
          mobile,
          fax,
          email,
          pages_ids,
          ad_account_ids,
          country_id: selectedCountry.id,
          state_id:this.selectedState.id,
          strategic_ids,
          ideology_ids,
          selectedCountry,
          strategyActionsSelected,
          ideologySelected,
          pagesSelected,
          accountsSelected,
          selectedState:this.selectedState,
          campaign_name_template,
          adset_name_template,
          ad_name_template
        };
        store.dispatch("newPartner", partner).then(() => {
          this.name = "";
          this.website = "";
          this.email = "";
          this.street = "";
          this.street_2 = "";
          this.phone = "";
          this.mobile = "";
          this.city="";
          this.fax = "";
          this.selectedCountry = {};
          this.accountsSelected = [];
          this.pagesSelected = [];
          this.ideologySelected = [];
          this.strategyActionsSelected = [];
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    openModalStrategy(){
      this.modalStrategy();
    },
    crearIdeologia(){
      /*this.isLoadingIdeologia = true;
      var {name,reach_estimate} = this.newIdeologia;
      if (
        name == "" ||
        reach_estimate == ""){
          this.isLoadingIdeologia = false;
        }else{
          var ideologia = {
            name,
            reach_estimate
          }
          store.dispatch("newStateCountry", ideologia).then(() => {
          this.newState = {
            name:"",
            code:"",
            country:{}
          };
          this.modalState = false
          this.isLoadingState = false;
        });
        }*/
    }
    
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>